import React from "react";

const Footer = ()=>{
    return(
        <div className="footer-wrapper">
            <div className="container">
                <div className="d-flex justify-content-between">
                    <p>Copyright 2022 Differential Capital All Rights Reserved.</p>
                    <p>Differential Capital (Pty) Ltd is an Authorised Financial Services Provider. FSP No.: 49982</p>
                </div>
            </div>
        </div>
    )
}

export default Footer;